import Vue, { DirectiveOptions } from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'
import i18n from '@/lang'

// @ts-ignore
import { ScaleResult, AssessResult } from 'childfit-ui'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'

// @ts-ignore
import Print from '@/utils/printjs'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router/index'
import '@/icons/components'
import '@/permission'

// import '@/registerServiceWorker'
import components from '@/components'
import * as filters from '@/filters' // 过滤器
import * as directives from '@/directives'
import globalFn from '@/utils' // 全局方法
import img from '@/utils/img' // 全局图片资源
import constants from '@/utils/constants' // 全局常量
import validate from '@/utils/validate' // 全局验证规则
import enums from '@/utils/enums' // 全局枚举
import domain from '@/utils/domain'
import { UserModule } from '@/store/modules/user'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import config from '@/utils/config'
// 全局配置
Vue.use(Print)

Vue.prototype.$config = config
Vue.component('ScaleResult', ScaleResult)// 图片点击放大预览
Vue.component('AssessResult', AssessResult)// 图片点击放大预览

// process.env.VUE_APP_MOCK && require('./mock/index.js')

// 判断code权限是否存在（返回布尔值）
Vue.prototype.$hasPermission = function(code:number) {
  return UserModule.accesses.map((item:any) => parseInt(item.code)).indexOf(code) > -1
}

// 注册全局组件
Object.keys(components).forEach(key => {
  var name = key.replace(/(\w)/, v => v.toUpperCase()) // 首字母大写
  // @ts-ignore
  Vue.component(`${name}`, components[key])
})
// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string ]: Function })[key])
})
// 注册全局指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, (directives as { [key: string ]: DirectiveOptions })[key])
})
// 全局方法
Vue.prototype.$fn = globalFn
// 全局验证规则
Vue.prototype.$valid = validate
// 全局枚举
Vue.prototype.$enums = enums
// 全局图片资源地址
Vue.prototype.$img = img
// 全局变量
Vue.prototype.$const = constants

Vue.prototype.domain = domain

// 封装element.$confirm
Vue.prototype.$verify = function(message: string, title: string) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$confirm(message, title, {
      type: 'warning',
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(() => {
      resolve(true)
    }).catch(() => {
      resolve(false)
    })
  })
}

Vue.prototype.$isArray = function(array: []) {
  if (array && array.length > 0) {
    return true
  } else {
    return false
  }
}

Vue.use(ElementUI, {
  i18n: (key: string, value: string) => i18n.t(key, value),
  size: 'small',
  zIndex: 1000 // dialog默认的z-index是2000，会覆盖v-viewer
})
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})
Vue.use(Viewer)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
